module.exports = __webpack_public_path__ + "img/Snowflake.3bed14ac.jpg";